import { Link } from "react-router";
import { ErrorState } from "../shared/ui/states";

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-[560px] px-10 py-16 text-center">
      <ErrorState title="Page not found" description="This address does not match anything here." />
      <Link to="/" className="text-sm no-underline" style={{ color: "var(--primary)" }}>
        Go to the documentation home
      </Link>
    </div>
  );
}
